import React from 'react';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from './messages';

const CountryColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  const { returnConfiguration } = ret || {};
  const { shipTo } = returnConfiguration || {};
  const { countryCode } = shipTo || {};

  return countryCode || '';
};

export const Country = {
  getMessageDescriptor: () => messages.country,
  id: 'country',

  render: ({ fulfillmentId }) => {
    return <CountryColumn fulfillmentId={fulfillmentId} />;
  },
};
